import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../../modules/actions/index';
import MapPerformance from '../../../../components/OrganizationSetup/MapPerformance/MapPerformance';

class MapPerformanceSetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.resetMapPerformanceStep();
  }

  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    return (<div className="mb20 mt60">
    <MapPerformance 
      onProcessedFileUploadData={this.handleFileUpload}
      onMapGenderMatchColumn={this.handleMatchColumn}
      onSkipPerformanceMapping={this.handleSkipMapping}
      {...this.props}/>
    </div>);
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapPerformance : state.mapping.performance
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapPerformanceStep: () => dispatch(actionCreators.resetMapPerformanceStep()),
    nextStep: () => dispatch(actionCreators.mapPerformanceNextStep()),
    goBack : () => dispatch(actionCreators.mapPerformanceGoBack()),
    saveAllPerformanceMapping : (o,s) => dispatch(actionCreators.saveAllPerformanceMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapPerformanceUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapPerformanceMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapPerformanceSetup);